import request from '@/untils/request'
export default {
  // 登录
  login(data) {
    return request({
      url: "/postLogin",
      methods: "post",
      params: {
        // "loginName": Base64.encode(data.username),
        // "password": Base64.encode(data.password),
        "loginName": data.username,
        "password": data.password,
        "verifycode": data.verifycode
      }
    })
  },

    // 获取验证码
    getVerifyCode(params) {
        return request({
          url: "/ticketAppUser/getVerifyCode",
          methods: "post",
          params
        })
      },

  // 短信验证码
  codess(data){
    return request({
        url: "/ticketAppUser/getSMSByPhone",
        methods: "post",
        params: {
          "phone": data.username,
          "verifycode": data.verifycode
        }
    })
  },

};



// WEBPACK FOOTER //
// ./src/api/login.js